module.exports = __webpack_public_path__ + "img/arrow-prev.fd91a129.svg";